import { useVatsQuery } from 'src/api/api.generated'
import useErrorSnackBar from '../error-snack-bar/error-snack-bar'

export function useGetSortedVats(tenantId: string) {
  const showError = useErrorSnackBar()
  const { data, loading } = useVatsQuery({
    variables: { tenantId },
    onError: showError,
  })
  const vats = [...(data?.vats ?? [])]

  return {
    vats: vats.sort((firstVat, secondVat) => {
      if (firstVat.value !== secondVat.value) return secondVat.value - firstVat.value
      else return firstVat.description.localeCompare(secondVat.description)
    }),
    loading,
  }
}
